interface IProps {
  children: JSX.Element;
  className?: string;
  onClick?: () => void;
}

const Icon = ({ children, className, onClick }: IProps) => {
  return (
    <i className={className} onClick={onClick}>
      {children}
    </i>
  );
};

export default Icon;
